import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import Link from '@fuse/core/Link';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

type HelpButtonProps = {
  className?: string;
};

function HelpButton(props: HelpButtonProps) {
  const { className = '' } = props;

  return (
    <Tooltip title="Help & FAQs" placement="bottom">
      <IconButton component={Link} to="/documentation/faqs" className={clsx('border border-divider', className)}>
        <FuseSvgIcon size={20}>heroicons-outline:question-mark-circle</FuseSvgIcon>
      </IconButton>
    </Tooltip>
  );
}

export default HelpButton;
